import { useEffect } from "react";
import Loader from "../../../packages/Loader/Loader";
import TopBar from "../topbar";
import { phonepeStatusCheckMiddleWare } from "./store/profileMiddleware";
import { useDispatch } from "react-redux";
import { LOCAL_STORE } from "../../../utils/LocalStoreConst";
import { useNavigate, useParams } from "react-router-dom";
import { cashFreeCallbackStatusMiddleWare } from "./../../../pages/kundali/store/kundaliMiddleware";

const CashFreePaymentStatusCheck = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orderId } = useParams();
  useEffect(() => {
    const payloadRequest = {
      orderId,
    };
    dispatch(
      cashFreeCallbackStatusMiddleWare({ payload: payloadRequest })
    ).then((res) => {
      if (res.payload?.message === "Success") {
        navigate("/kundali/payment/success?page=wallet");
      } else {
        navigate("/kundali/payment/failed?page=wallet");
      }
    });
  }, []);

  return (
    <div style={{ height: "100vh" }} className="topDiv ">
      <TopBar />
      <Loader />
    </div>
  );
};

export default CashFreePaymentStatusCheck;
